/** Thrown by API helpers when the server returns a non-OK response; preserves the raw body for debugging/copy. */
export class ApiRequestError extends Error {
  readonly status: number;
  readonly responseBody: string;

  constructor(message: string, status: number, responseBody: string) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
    this.responseBody = responseBody;
  }
}
